"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchButton = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var ColorPatterns;

(function (ColorPatterns) {
  ColorPatterns["light"] = "GREY[\"200\"]";
  ColorPatterns["dark"] = "GREY.LIGHT";
})(ColorPatterns || (ColorPatterns = {}));

var makePatternStyles = function makePatternStyles(colorPattern, theme) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(ColorPatterns[colorPattern]), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(ColorPatterns[colorPattern]), theme), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.MEDIUM", theme));
};

var SizeTop;

(function (SizeTop) {
  SizeTop["small"] = "0.25rem";
  SizeTop["medium"] = "0.5rem";
})(SizeTop || (SizeTop = {}));

exports.SearchButton = (0, styled_components_1.default)(ui_butticon_1.Butticon).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['colorPattern', 'sizeOption'].includes(prop);
  }
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  right: 0.25rem;\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n\n  ", "\n\n  svg {\n    height: 0.75rem;\n    width: 0.75rem;\n  }\n\n  > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"], ["\n  position: absolute;\n  top: ", ";\n  right: 0.25rem;\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n\n  ", "\n\n  svg {\n    height: 0.75rem;\n    width: 0.75rem;\n  }\n\n  > div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])), function (_a) {
  var _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'small' : _b;
  return SizeTop[sizeOption];
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makePatternStyles);
});
var templateObject_1, templateObject_2;